import * as React from 'react'

import { cn } from 'lib/utils.js'
import { useField } from 'formik'
import { Label } from 'components/ui/label'
import ReactInputMask from 'react-input-mask'

const ArticelInput = React.forwardRef(({ className, type, label, value, ...props }, ref) => {
  const [field, , helpers] = useField(props)

  React.useEffect(() => {
    if (value) {
      helpers.setValue(value)
    }
    // eslint-disable-next-line
  }, [value])

  return (
    <div className={`grid ${label ? 'grid-cols-[100px_1fr]' : ''} items-center`}>
      <Label htmlFor={props.name} className="text-simsek">
        {label}
      </Label>
      <ReactInputMask
        id={props.name}
        mask="9999/999"
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-black outline-none disabled:cursor-not-allowed',
          className
        )}
        ref={ref}
        {...field}
        {...props}
      />
    </div>
  )
})

ArticelInput.displayName = 'ArticelInput'

export { ArticelInput }
